// Client-side module-permission helpers.
//
// NOTE: this is UX only (hides menus/routes the user can't use). Real
// authorization is enforced on the backend via the `module:<key>` middleware —
// never rely on this for security.

// Bundled module catalogue (mirrors backend App\Support\Modules::CATALOG).
// Used so the Role screen always renders checkboxes even if the /modules
// endpoint is unavailable; the backend is still the source of truth on save.
export const MODULE_CATALOG = [
  { key: "employee", label: "Employees" },
  { key: "attendance", label: "Attendance" },
  { key: "payroll", label: "Payroll" },
  { key: "tds", label: "TDS" },
  { key: "arrears", label: "Arrears" },
  { key: "incentive", label: "Incentive" },
  { key: "penalty", label: "Penalty" },
  { key: "reimbursement", label: "Reimbursement" },
  { key: "bonus", label: "Bonus" },
  { key: "earned_leave", label: "Earned Leave" },
  { key: "esic_pf", label: "ESIC / PF" },
  { key: "reports", label: "Reports" },
  { key: "users", label: "Users" },
  { key: "roles", label: "Roles" },
  { key: "track_sheet", label: "Track Sheet" },
];

export const getUserType = () => localStorage.getItem("type") || "";

export const getUserModules = () => {
  try {
    const raw = localStorage.getItem("modules");
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (e) {
    return [];
  }
};

export const isSuperAdmin = () => getUserType() === "Super Admin";

// Full-access roles always pass (also a safety net for sessions created before
// `modules` was returned by login).
export const hasModule = (key) => {
  if (!key) return true;
  const type = getUserType();
  if (type === "Super Admin" || type === "Admin") return true;
  return getUserModules().includes(key);
};

// Ordered route -> required module map. Order also decides the landing page
// for limited roles (first allowed route wins). Routes not listed here
// (e.g. /employee-data, /salary-view) require no module.
export const ROUTE_MODULES = [
  ["/employee", "employee"],
  ["/attendance", "attendance"],
  ["/payroll", "payroll"],
  ["/report", "reports"],
  ["/incentive", "incentive"],
  ["/penalty", "penalty"],
  ["/tds", "tds"],
  ["/arrear", "arrears"],
  ["/reimbursement", "reimbursement"],
  ["/bonus", "bonus"],
  ["/earned-leave", "earned_leave"],
  ["/employeer-component", "employee"],
  ["/employee-bank-details", "employee"],
  ["/track-sheet", "track_sheet"],
  ["/user", "users"],
  ["/role", "roles"],
];

export const moduleForPath = (pathname) => {
  const match = ROUTE_MODULES.find(
    ([route]) => pathname === route || pathname.startsWith(route + "/")
  );
  return match ? match[1] : null;
};

// First route the current user is allowed to open; used as the post-login
// landing / fallback for blocked pages.
export const firstAllowedRoute = () => {
  const match = ROUTE_MODULES.find(([, mod]) => hasModule(mod));
  return match ? match[0] : "/employee-data";
};
